import NavTabs from "~/scripts/nav-tabs.js";


customElements.define("nav-tabs", NavTabs);

